<template>
    <div class="flex items-center gap-4">
        <div class="w-full flex-1 bg-[#FFEAE6] rounded-full h-2">
            <div
                class="bg-orange-600 h-2 rounded-full transition-all"
                :style="`width: ${progress}%`"
            ></div>
        </div>
        <p class="text-slate-500 dark:text-slate-400 text-sm font-medium">
            {{ progress }}% completed
        </p>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useCoursesStore } from '@/store/courses';

const store = useCoursesStore();
const { progress } = storeToRefs(store);
</script>
